import { handleActions } from 'redux-actions';
import { logoutSuccess } from 'ducks/auth/actions';
import initialState from './states';
import { AskStatus } from './types';
import {
  askRequest,
  askSuccess,
  askFailure,
  resetAsk,
  setCategory,
  feedbackRequest,
  feedbackFailure,
} from './actions';

export default handleActions(
  {
    [setCategory](state, { payload }) {
      return { ...state, category: payload, error: null };
    },
    [askRequest](state, { payload: { question, category } }) {
      return {
        ...state,
        category: category || state.category,
        status: AskStatus.LOADING,
        error: null,
        messages: [...state.messages, { role: 'user', text: question }],
      };
    },
    [askSuccess](state, { payload }) {
      return {
        ...state,
        status: AskStatus.IDLE,
        category: payload?.category || state.category,
        messages: [
          ...state.messages,
          { role: 'assistant', text: payload?.answer || '', logID: payload?.logID || null },
        ],
        monthlyTokensUsed: payload?.monthlyTokensUsed || state.monthlyTokensUsed,
        monthlyTokenLimit: payload?.monthlyTokenLimit || state.monthlyTokenLimit,
        monthlyTokensRemaining:
          payload?.monthlyTokensRemaining != null
            ? payload.monthlyTokensRemaining
            : state.monthlyTokensRemaining,
        error: null,
      };
    },
    [askFailure](state, { payload }) {
      return {
        ...state,
        status: AskStatus.ERROR,
        error: payload?.error || 'ai_request_failed',
      };
    },
    // Optimistically reflect the rating; revert on failure.
    [feedbackRequest](state, { payload: { logID, helpful } }) {
      if (logID == null) return state;
      return { ...state, feedback: { ...state.feedback, [logID]: helpful } };
    },
    [feedbackFailure](state, { payload }) {
      const logID = payload?.logID;
      if (logID == null) return state;
      const feedback = { ...state.feedback };
      delete feedback[logID];
      return { ...state, feedback };
    },
    [resetAsk](state) {
      return {
        ...initialState,
        category: state.category,
        monthlyTokensUsed: state.monthlyTokensUsed,
        monthlyTokenLimit: state.monthlyTokenLimit,
        monthlyTokensRemaining: state.monthlyTokensRemaining,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
